/* ============================================================
   TFS Wheels — Header mega-menu interactions
   Ported from docs/header-redesign/mockup.js. The garage popover
   is intentionally omitted: the "Add a Vehicle" control is the
   fitment app's garage-widget.js (#tfs-garage-root), which mounts
   and manages its own dropdown.
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var body = document.body;

    /* ---- 1. Sticky condense: collapse utility strip + shrink bar.
       Hysteresis (stick at >64px, release at <16px) is deliberate: collapsing
       the utility strip removes ~38px from above the fold, which scroll-anchoring
       can nudge scrollY back across a single threshold — making the header
       oscillate ("vibrate"). A dead-zone wider than that shift breaks the loop. */
    var stuck = false;
    function onScroll() {
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      if (!stuck && y > 64) { stuck = true; body.classList.add('is-stuck'); }
      else if (stuck && y < 16) { stuck = false; body.classList.remove('is-stuck'); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* ---- 2. Mega menus: hover opens via CSS; click/keyboard toggles for touch + a11y ---- */
    var megas = Array.prototype.slice.call(document.querySelectorAll('[data-mega]'));
    function closeAllMegas(except) {
      megas.forEach(function (m) {
        if (m !== except) {
          m.classList.remove('is-open');
          var b = m.querySelector('.navlink');
          if (b) b.setAttribute('aria-expanded', 'false');
        }
      });
    }
    megas.forEach(function (m) {
      var btn = m.querySelector('.navlink');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var open = m.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        closeAllMegas(m);
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-mega]')) closeAllMegas(null);
    });

    /* ---- 3. Search drawer ---- */
    var searchBtn = document.querySelector('[data-search-toggle]');
    var searchbar = document.querySelector('[data-searchbar]');
    function openSearch() {
      if (!searchbar) return;
      searchbar.classList.add('open');
      searchbar.setAttribute('aria-hidden', 'false');
      if (searchBtn) searchBtn.setAttribute('aria-expanded', 'true');
      closeAllMegas(null);
      var input = searchbar.querySelector('input');
      if (input) setTimeout(function () { input.focus(); }, 120);
    }
    function closeSearch() {
      if (!searchbar) return;
      searchbar.classList.remove('open');
      searchbar.setAttribute('aria-hidden', 'true');
      if (searchBtn) searchBtn.setAttribute('aria-expanded', 'false');
    }
    if (searchBtn && searchbar) {
      searchBtn.addEventListener('click', function () {
        if (searchbar.classList.contains('open')) { closeSearch(); } else { openSearch(); }
      });
    }

    /* ---- 4. Mobile drawer ---- */
    var drawer = document.querySelector('[data-drawer]');
    var drawerBack = document.querySelector('[data-drawer-back]');
    var openBtn = document.querySelector('[data-drawer-open]');
    var closeBtn = document.querySelector('[data-drawer-close]');
    function openDrawer() {
      if (drawer) { drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); }
      if (drawerBack) drawerBack.classList.add('open');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      body.style.overflow = 'hidden';
      closeAllMegas(null);
      closeSearch();
    }
    function closeDrawer() {
      if (drawer) { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); }
      if (drawerBack) drawerBack.classList.remove('open');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      body.style.overflow = '';
    }
    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (drawerBack) drawerBack.addEventListener('click', closeDrawer);

    /* ---- 5. Mobile accordions ---- */
    Array.prototype.slice.call(document.querySelectorAll('[data-acc]')).forEach(function (acc) {
      var btn = acc.querySelector('button');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = acc.classList.toggle('open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* ---- 6. Global Escape: close whatever is open ---- */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeAllMegas(null);
      closeSearch();
      if (drawer && drawer.classList.contains('open')) closeDrawer();
    });

    /* ---- 7. Deep-link auto-open (handy for QA / verification) ----
       ?mega=shop|brands|resources  ?search=1  ?drawer=1  ?acc=1 */
    try {
      var p = new URLSearchParams(window.location.search);
      var megaName = p.get('mega');
      if (megaName) {
        var map = { shop: '.mega-shop', brands: '.mbrands', resources: '.mres' };
        var sel = map[megaName.toLowerCase()];
        if (sel) {
          var panel = document.querySelector(sel);
          var host = panel && panel.closest('[data-mega]');
          if (host) {
            host.classList.add('is-open');
            var hb = host.querySelector('.navlink');
            if (hb) hb.setAttribute('aria-expanded', 'true');
          }
        }
      }
      if (p.get('search') === '1') openSearch();
      if (p.get('drawer') === '1') openDrawer();
      if (p.get('acc') === '1') {
        Array.prototype.slice.call(document.querySelectorAll('[data-acc]')).forEach(function (a) {
          a.classList.add('open');
          var b = a.querySelector('button');
          if (b) b.setAttribute('aria-expanded', 'true');
        });
      }
    } catch (e) { /* no-op */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
